import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, checked } = useAuth();
  if (!checked) {
    return (
      <div className="min-h-screen bg-[#F5F3EC] flex items-center justify-center" data-testid="loading">
        <div className="font-mono-label text-xs text-[#5C635F]">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin" replace />;
  return children;
}
